import './css/index.css';
import { object } from 'prop-types';
import React from 'react';

const Disclaimer = ( { disclaimer } ) => {

    return (
        <div className="disclaimer">
            <p dangerouslySetInnerHTML={ { __html: disclaimer.notes } }></p>
            <p dangerouslySetInnerHTML={ { __html: disclaimer.sources } }></p>
        </div>
    );

};

Disclaimer.propTypes = {
    disclaimer: object,
};

export default Disclaimer;
